<template>
  <div class="record-edit-wrapper">
    <!-- 第一部分 -->
    <div class="form-wrapper" :style="{marginTop: (page == 'enter' ? '12' : '0') + 'px'}">
      <div class="form-item vertical" v-if="page == 'edit'">
        <div class="form-type"><span>就诊人信息</span></div>
        <div class="form-content">
          <div class="patient-info">{{patientInfo.pat_username}}<span>|</span>{{patientInfo.gender | genderFilter}}<span>|</span>{{patientInfo.birthday | ageFilter}}</div>
        </div>
      </div>
      <!-- 初诊照片上传 -->
      <div class="form-item vertical">
        <div class="form-type"><span class="required">上传 <em>初诊病历</em> 及 <em>处方单</em></span><span class="type-tips">最多上传9张</span></div>
        <div class="form-content">
          <div class="upload-list">
            <div class="upload-item" v-for="(item, index) in recordImgList">
              <span class="delPic" v-if="item.status == 5" @click="delPic(item, 'recordImgList', 'recordOssList')"><icon icon-class="close"></icon></span>
              <div class="preview-box">
                <img :src="item.previewImage" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="recordImgList.length < 9">
              <div class="uploader-box" id="recordUploader">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 是否吸烟 -->
      <div class="form-item click" @click="smokePickerShow = true">
        <div class="form-type"><span>是否吸烟</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!smoke">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{smoke}}</div>
        </div>
      </div>
      <!-- 是否饮酒 -->
      <div class="form-item click" @click="drinkPickerShow = true">
        <div class="form-type"><span>是否饮酒</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!drink">请选择<icon icon-class="arrow" /></div>
          <div class="picker-value" v-else>{{drink}}</div>
        </div>
      </div>
      <!-- 是否家族遗传病 -->
      <div class="form-item vertical">
        <div class="form-type"><span>是否有家族遗传病史</span></div>
        <div class="form-content">
          <textarea class="form-textarea low-height" v-model="genetic" v-ios-bug-fixed placeholder="是否有家族遗传病史，如有请说明" maxlength="100"></textarea>
          <span class="textarea-limit">{{genetic.length}}/100</span>
        </div>
      </div>
      <!-- 既往重大疾病史 -->
      <div class="form-item vertical">
        <div class="form-type"><span>既往重大疾病史</span></div>
        <div class="form-content">
          <textarea class="form-textarea low-height" v-model="seriousIllness" v-ios-bug-fixed placeholder="是否有高血压、糖尿病、高脂血症、冠心病，肝炎、结核病等传染病史，外伤史、手术史等" maxlength="100"></textarea>
          <span class="textarea-limit">{{seriousIllness.length}}/100</span>
        </div>
      </div>
    </div>
    <!-- 第二部分 -->
    <div class="form-wrapper">
      <!-- 上传辅助检查结果 -->
      <div class="form-item vertical">
        <div class="form-type"><span>上传现有辅助检查结果、报告</span><span class="type-tips">最多上传9张</span></div>
        <div class="form-content">
          <div class="upload-list">
            <div class="upload-item" v-for="(item, index) in reportImgList">
              <span class="delPic" v-if="item.status == 5" @click="delPic(item, 'reportImgList', 'reportOssList')"><icon icon-class="close"></icon></span>
              <div class="preview-box">
                <img :src="item.previewImage" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="reportImgList.length < 9">
              <div class="uploader-box" id="reportUploader">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-box" :class="{'edit': this.page == 'edit'}"><button class="submit-button" @click="finishBind" :disabled="submitting">完成绑定</button></div>

    <!-- 吸烟选择 -->
    <van-popup v-model="smokePickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="smokeOptions"
        value-key="label"
        @cancel="smokePickerShow = false"
        @confirm="confirmSmoke"
      />
    </van-popup>

    <!-- 饮酒选择 -->
    <van-popup v-model="drinkPickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="drinkOptions"
        value-key="label"
        @cancel="drinkPickerShow = false"
        @confirm="confirmDrink"
      />
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .entering-wrapper{
    background: #F7F7F7;
  }
  .form-wrapper{
    padding: 24px 0 12px;
    // margin-top: 12px;
    background: #FFF;
    .form-item{
      position: relative;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FFF;
      height: 40px;
      margin-bottom: 16px;
      transition: all .1s;
      &.vertical{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        .form-content{
          position: relative;
          width: 100%;
          margin-top: 16px;
          .form-textarea{
            border: 1px solid #F7F7F7;
            background: #F7F7F7;
            resize: none;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: #666;
            width: 100%;
            height: 144px;
            &::-webkit-input-placeholder{
              color: #999;
            }
            &.low-height{
              height: 96px;
            }
          }
          .textarea-limit{
            position: absolute;
            right: 8px;
            bottom: 8px;
            font-size: 12px;
            color: #999;
          }
          .upload-list{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            margin-bottom: -16px;
            .upload-item{
              position: relative;
              width: 96px;
              height: 96px;
              margin: 0 16px 16px 0;
              &:nth-child(3n){
                margin-right: 0
              }
              .preview-box{
                position: relative;
                width: 100%;
                height: 100%;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                border-radius: 4px;
                background: #000;
                img{
                  width: 100%;
                }
                .image-status{
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 20px;
                  line-height: 20px;
                  background: rgba(0, 0, 0, .5);
                  color: #FFF;
                  text-align: center;
                  font-size: 12px;
                }
              }
              .delPic{
                position: absolute;
                top: -8px;
                right: -8px;
                width: 20px;
                height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #DDD;
                border-radius: 50%;
                background: #FFF;
                z-index: 20;
                svg{
                  font-size: 12px;
                  color: #999;
                }
              }
              &.uploader{
                .uploader-box{
                  width: 100%;
                  height: 100%;
                  border: 1px dashed #CCC;
                  background: #F3F3F3;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 4px;
                  svg{
                    font-size: 28px;
                    color: #CCC;
                  }
                }
              }
            }
          }
          .patient-info{
            color: @black;
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;
            vertical-align: middle;
            margin-top: -8px;
            span{
              font-size: 12px;
              color: #CCC;
              margin: 0 12px;
              font-weight: normal;
            }
          }
        }
      }
      &.avatar{
        height: 80px;
        margin-bottom: 12px;
      }
      &.click{
        cursor: pointer;
        &:active{
          background: #F9F9F9;
        }
      }
      &.error{
        margin-bottom: 28px;
        .form-content .form-text{
          color: @error;
        }
      }
      .form-type{
        font-size: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          em{
            color: @xile;
          }
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        .tips{
          margin-top: 6px;
          font-size: 12px;
          color: @xile;
        }
        .type-tips{
          margin-left: 15px;
          font-size: 14px;
          color: #999;
        }
      }
      .form-content{
        color: #666;
        font-size: 16px;
        .avatar-box{
          width: 64px;
          height: 64px;
          img{
            width: 100%;
          }
        }
        .form-text{
          width: 200px;
          border: 0;
          text-align: right;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .picker-tips{
          font-size: 16px;
          color: #999;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          svg{
            position: relative;
            top: 2px;
            font-size: 14px;
            margin-left: 4px;
          }
        }
        .picker-value{
          max-width: 240px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .get-code-button{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 32px;
          border: 1px solid @xile;
          color: @xile;
          font-weight: bold;
          background: transparent;
          font-size: 12px;
          border-radius: 4px;
          transition: all .1s;
          &:disabled{
            border-color: #CCC;
            color: #CCC;
            &:active{
              opacity: 1;
            }
          }
          &:active{
            opacity: .8;
          }
        }
      }
      .code-input-box{
        .code-input{
          width: 200px;
          border: 0;
          font-size: 16px;
          line-height: 40px;
          color: #666;
          background: transparent;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
      }
      .form-error{
        position: absolute;
        right: 16px;
        top: 100%;
        font-size: 12px;
        color: @error;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .van-icon{
          position: relative;
          top: 1px;
          width: 12px;
          height: 12px;
          background: @error;
          color: #FFF;
          border-radius: 50%;
          margin-right: 4px;
        }
      }
    }
  }
  .submit-box{
    padding: 24px 16px 12px;
    &.edit{
      padding: 24px 0 12px;
    }
    .submit-button{
      @button-base();
      width: 100%;
      height: 40px;
      font-size: 14px;
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      page: {
        type: String,
        default: 'enter'
      },
      patientInfo: {
        type: Object,
        default: () => {
          return {
            pat_username: '默认患者名字',
            gender: 1,
            birthday: '2018/1'
          }
        }
      },
      privateId: [String, Number],
      docId: [String, Number],
    },
    data() {
      return {
        submitting: false,
        // 上传病历照片实例
        recordUploader: null,
        recordImgList: [],
        recordOssList: [],
        // 上传现有辅助检查结果、报告实例
        reportUploader: null,
        reportImgList: [],
        reportOssList: [],
        // 吸烟
        smoke: '',
        smokePickerShow: false,
        smokeOptions: ['是', '否'],
        // 饮酒
        drink: '',
        drinkPickerShow: false,
        drinkOptions: ['是', '否'],
        // 遗传病
        genetic: '',
        // 重大病史
        seriousIllness: '',
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    mounted() {
      this.setMultipleUpload(this.recordUploader, 'recordUploader', 'recordImgList', 'recordOssList');
      this.setMultipleUpload(this.reportUploader, 'reportUploader', 'reportImgList', 'reportOssList');
    },
    methods: {
      // 上传多张张函数
      setMultipleUpload(obj, id, file, finalList) {
        let _this = this;
        obj = new plupload.Uploader({
        runtimes: 'html5,flash,silverlight,html4',
        browse_button: id,
        flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
        silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
        url: 'http://oss.aliyuncs.com',
        // 不检测重复文件
        filters: {
          // mime_types: [
          //   {title: "image", extensions: "image/*,jpg,jpeg,png,bmp"}
          // ],
          // mime_types: 'image/*',
          // prevent_duplicates: true,
        },
        // 多文件上传
        multi_selection: true,
        init: {
          // 选择文件之后
          FilesAdded(up, files) {
            // 获取当前已上传的图片数量
            let objLength = _this[file].length;
            files.forEach(item => {
              // 如果本次选中的图片数量超出了9张的限制，则自动删除多出的图片
              objLength++;
              if(objLength > 9) {
                up.removeFile(item);
              };
              let fileName = item.name;
              _this.$root.previewUploadImage(item, (imgSrc) => {
                item.previewImage = imgSrc;
                _this[file].push(item);
              })
            })
            _this.$root.setUploadParam(up, '', false);
          },
          // 上传前设置文件名
          BeforeUpload(up, fileObj) {
            _this.$root.setUploadParam(up, fileObj.name, true);
          },
          // 上传完成
          FileUploaded(up, fileObj, info) {
            if(info.status == 200) {
              let res = JSON.parse(info.response);
              _this[finalList].push(res.path)
              // _this.avatar = res.path;
            }
          },
          Error(up, err) {
            console.log(err);
          }
        }
      })
      // 初始化上传
      obj.init();
      },
      // 删除已上传的图片
      delPic(item, obj, ossObj) {
        let index = this[obj].indexOf(item)
        this[obj].splice(index, 1);
        this[ossObj].splice(index, 1);
      },
      confirmSmoke(value) {
        this.smoke = value;
        this.smokePickerShow = false;
      },
      confirmDrink(value) {
        this.drink = value;
        this.drinkPickerShow = false;
      },
      // 完成绑定
      finishBind() {
        if(this.recordOssList.length == 0) {
          this.$notify('请上传您的初诊病历及处方单');
          return;
        }
        let postData = {
          id: this.privateId,
          user_id: this.userInfo.user_id,
          doc_id: this.docId,
          case_img: this.recordOssList,
          is_smoke: this.smoke ? (this.smoke == '是' ? 1 : 2) : 3,
          is_drink: this.drink ? (this.drink == '是' ? 1 : 2) : 3,
          gen_disease: this.genetic,
          ser_disease: this.seriousIllness,
          result_img: this.reportOssList.length > 0 ? this.reportOssList : '',
        }
        console.log(postData);
        this.submitting = true;
        this.$root.post('/setPatientInfo', postData).then(data => {
          this.submitting = false;
          console.log(data);
          if(data.status == 1) {
            this.$emit('success');
          }else {
            this.$notify(data.msg);
          }

        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/firstRecordEdit.vue